<template>
  <v-row v-for="crit in criteria" :key="crit.id">
    <v-col cols="12" v-if="crit.criteria">
      <v-img
        v-if="crit.criteria.thubmnail"
        width="125px"
        contain
        :src="crit.criteria.thubmnail.url">
        <template #sources> <source :srcset="crit.criteria.thubmnail?.webp_url" /> </template
      ></v-img>
    </v-col>
    <v-col cols="12">
      {{ crit.criteria?.name }}

      <div class="pb-2" v-html="crit.criteria?.description"></div>
    </v-col>
    <v-col cols="12">
      <v-text-field
        v-model="crit.use_of_criteria"
        label="How was the criteria used in the film?"
        :rules="[rules.required]"
        @input="emit('update', crit, isManditory)"></v-text-field>
    </v-col>
    <v-col cols="12" v-if="!isManditory">
      <v-tooltip location="end">
        <template #activator="{ props: tooltipProps }">
          <v-icon
            v-bind="tooltipProps"
            icon="mdi-trash-can-outline"
            @click="emit('remove', crit, isManditory)" />
        </template>
        Remove Optional Criteria
      </v-tooltip>
    </v-col>

    <v-divider></v-divider>
  </v-row>
</template>
<script setup lang="ts">
import { TeamCriteriaSelectionDTO } from '@/dtos';
import { rules } from '@/helpers';
import { computed, ref, watch } from 'vue';

interface Props {
  selection: TeamCriteriaSelectionDTO[];
  isManditory?: boolean;
  isRequired?: boolean;
}
const props = defineProps<Props>();
const emit = defineEmits<{
  (e: 'update', value: TeamCriteriaSelectionDTO, isManditory: boolean): void;
  (e: 'remove', value: TeamCriteriaSelectionDTO, isManditory: boolean): void;
}>();
const criteria = ref<TeamCriteriaSelectionDTO[]>([]);
const isManditory = computed(() => props.isManditory ?? false);

watch(
  () => props.selection,
  (newSelection) => {
    criteria.value =
      newSelection?.map((selected) => {
        return new TeamCriteriaSelectionDTO(selected);
      }) ?? [];
  },
  { immediate: true },
);
</script>
